import { useResizeObserver, useScrollPosition } from '../effects/useScrollPosition';
import { useScrollLock } from '../effects/useScrollLock';
import './Modal.scss';


function Modal({ children, footer = null, isOpen = false, onClose, className = '', footerClassName = '', style = {}, mode }) {
    const { scrollPosition, divRef } = useScrollPosition();
    const { dimensions, elRef } = useResizeObserver();
    useScrollLock(isOpen);
    var classes = `${className} ${mode ?? ''}`;
    if (isOpen) {
        classes += ' is-open ';
    } else {
        return null;
    }


    if (scrollPosition.y > 10) {
        classes += ' has-scroll ';
    }

    let combinedStyles = {
        ...style
    }
    combinedStyles['--modal-height'] = `${dimensions.height}px`;
    combinedStyles['--modal-width'] = `${dimensions.width}px`;





    return (<div onClick={onClose} className={`Modal__overlay ${classes}`} style={combinedStyles}>
        <div onClick={(e) => e.stopPropagation()} ref={elRef} className="Modal">
            <button type='button' onClick={onClose} className="Modal__close" aria-label='Close'>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 5.5L5 15.5M5 5.5L15 15.5" stroke="#121212" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

            </button>
            <div ref={divRef} className="Modal__content">
                {children}
            </div>
            {footer ? (
                <div className={`Modal__footer ${footerClassName}`}>
                    {footer}
                </div>
            ) : null}
        </div>
    </div>
    )
}

export {
    Modal
}